import { Component } from '@angular/core';
import { NavController, NavParams, Events } from 'ionic-angular';

import { Api } from '../../providers/api/api';
import { IPTV } from '../../providers/iptv/iptv';
import { User } from '../../providers/user/user';
import { Utils } from '../../providers/utils/utils';
import { Fav }   from '../../providers/fav/fav';
import { TabsMain }  from '../tabsmain/tabsmain';

/*
*
*  Channel Page
*
*/
@Component({
  selector: 'channel',
  templateUrl: 'channel.html'
})
export class Channel {

    public channels : any = [];
    public category: any = {};
    public title: any;

    constructor( 
        private navCtrl: NavController, 
        private params: NavParams, 
        public utils: Utils,
        public events: Events, 
        public IPTV: IPTV,
        private api : Api,
        public user: User,
        public fav: Fav
    ) {
       this.category  = this.params.data,10;
       this.title     = this.utils.truncate(this.category.name,10,'...');


        this.events.subscribe('app:refresh', (params : any = {}) => { 
            if (this.navCtrl.canGoBack()) 
                this.navCtrl.setRoot(TabsMain);{
            }
        });

        this.events.subscribe('favorite:refresh', (params : any = {}) => { 
            this.fetch(true);
        });
    }

    ionViewWillEnter(){
        this.navCtrl.swipeBackEnabled = true;
    }
      
    ionViewDidLeave() {
        this.navCtrl.swipeBackEnabled = true;
    }
    
    ionViewDidLoad() {  
        this.fetch();
    }

    navPop() {
        this.navCtrl.pop();
    }

    doRefresh(refresher) {

        this.getChannels(true).then((data: any = []) => {
            this.channels = data;
            let that = this;

            this.fav.getFavorites(true).then((data2 : any = []) => {

                for(let channel of that.channels) {
                    channel.fav = false;
                    for(let fav of data2) {
                        if (fav.id == channel.id) {
                            channel.fav = true;
                        } 
                    }
                }

                refresher.complete();
            }, (err) => {
                refresher.complete();
                this.utils.error(err);
            });
            
        }, (err) => {
           refresher.complete();
            this.utils.error(err);
        });

    }


    fetch(noLoad:boolean=false, writeCache:boolean=false) {

        if (!noLoad) this.utils.load();

        this.getChannels(writeCache).then((data: any = []) => {
            this.channels = data;
            let that = this;

            this.fav.getFavorites(writeCache).then((data2 : any = []) => {

                for(let channel of that.channels) {
                    channel.fav = false;
                    for(let fav of data2) {
                        if (fav.id == channel.id) {
                            channel.fav = true;
                        } 
                    }
                }

                if (!noLoad) this.utils.unload();
            }, (err) => {
                if (!noLoad) this.utils.unload();
                this.utils.error(err);
            });
            
        }, (err) => {
            if (!noLoad) this.utils.unload();
            this.utils.error(err);
        });
    }

    getChannels(writeCache:boolean=false) {
        return new Promise((resolve, reject) => {
            this.api.getCached('/iptv/channel/'+this.IPTV.boxID+'/'+this.category.id, { writeCache:writeCache }).subscribe((response:any)=>{
                resolve(response.result.result);
            },(err) => {
                reject(this.api.reject(err));
            });
       });
    }

    
}






// WEBPACK FOOTER //
// ./src/pages/channel/channel.ts